import axios from "axios";
import APIUrl from "../APIUrl";

/**
 * Clears all authentication data from the application.
 * This includes session storage, axios headers, and forces a page reload.
 * Used when corrupted or invalid JWT tokens are detected.
 */
export function clearAuthentication() {
  // Clear sessionStorage
  sessionStorage.removeItem("jwt");
  sessionStorage.removeItem("companyId");
  sessionStorage.removeItem("userId");
  sessionStorage.removeItem("userRole");

  // Clear axios headers
  delete axios.defaults.headers.common["jwtToken"];
  delete axios.defaults.headers["jwtToken"];
  delete APIUrl.jwtToken;

  // Force page reload to ensure clean state
  setTimeout(() => {
    window.location.reload();
  }, 1000);
}
